import { apiSlice } from './apiSlice'
export const integrationsAPI = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getIntegration: builder.query({
      query: () => `/v1/integrations`,
      providesTags: result =>
        result && result.data
          ? [
              ...result.data.map(({ provider }) => ({ type: 'Integrations', id: provider })),
              { type: 'Integrations', id: 'LIST' }
            ]
          : [{ type: 'Integrations', id: 'LIST' }]
    }),
    getAccount: builder.query({
      query: () => `/v1/account`,
      providesTags: [{ type: 'Account', id: 'LIST' }]
    }),
    getAvailableConnectors: builder.query({
      query: () => '/v1/connectors',
      providesTags: [{ type: 'Connectors', id: 'LIST' }]
    }),
    uploadCsvUserList: builder.mutation({
      query: file => {
        const formData = new FormData()
        formData.append('csvUpload', file)
        return {
          url: '/v1/users/import',
          method: 'POST',
          body: formData,
          responseHandler: async response => {
            if (response.status === 206) {
              const blob = await response.blob()
              const contentDisposition = response.headers.get('content-disposition')
              let filename = 'import-details.csv'
              if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="([^"]+)"/)
                if (filenameMatch && filenameMatch[1]) {
                  filename = filenameMatch[1]
                }
              }
              return { data: blob, filename, status: response.status }
            }
            if (response.headers.get('content-type')?.includes('application/json')) {
              const data = await response.json()
              return { data, status: response.status }
            }

            const text = await response.text()
            try {
              const data = JSON.parse(text)
              return { data, status: response.status }
            } catch (e) {
              return { data: text, status: response.status }
            }
          }
        }
      }
    }),
    syncIntegration: builder.mutation({
      query: integrationType => ({
        url: `/v1/${integrationType.toLowerCase()}/sync`,
        method: 'POST'
      }),
      invalidatesTags: () => [
        { type: 'Integrations', id: 'LIST' },
        { type: 'Connectors', id: 'LIST' }
      ]
    }),
    getCompanyDomains: builder.query({
      query: () => '/v1/company-domains',
      providesTags: [{ type: 'CompanyDomains', id: 'LIST' }]
    }),
    getPossibleCompanyDomains: builder.query({
      query: ({ domain }) => {
        return {
          url: '/v1/company-domains/possible-emails',
          method: 'GET',
          params: {
            domain
          }
        }
      },
      providesTags: [{ type: 'CompanyDomains', id: 'POSSIBLE_LIST' }]
    }),
    verifyCompanyDomain: builder.mutation({
      query: ({ email }) => ({
        url: '/v1/company-domains/verify-request',
        method: 'POST',
        body: { email }
      }),
      invalidatesTags: [{ type: 'CompanyDomains', id: 'LIST' }]
    }),
    verifyEmailByToken: builder.mutation({
      query: ({ token }) => ({
        url: `/v1/company-domains/verify?token=${token}`,
        method: 'POST'
      }),
      invalidatesTags: [{ type: 'CompanyDomains', id: 'LIST' }]
    })
  })
})

export const {
  useVerifyEmailByTokenMutation,
  useGetAccountQuery,
  useVerifyCompanyDomainMutation,
  useGetCompanyDomainsQuery,
  useLazyGetPossibleCompanyDomainsQuery,
  useGetIntegrationQuery,
  useGetAvailableConnectorsQuery,
  useUploadCsvUserListMutation,
  useSyncIntegrationMutation
} = integrationsAPI
